/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { RoleId } from "../../commons/types/RoleId";
import { ResourceIdUnion } from "./ResourceIdUnion";
export const AssignActorRoleRequest = core.serialization.object({
    roleId: RoleId,
    resourceId: ResourceIdUnion,
});
